export default {
  'Hà Nội': [
    'Quận Ba Đình',
    'Quận Bắc Từ Liêm',
    'Quận Cầu Giấy',
    'Quận Đống Đa',
    'Quận Hà Đông',
    'Quận Hai Bà Trưng',
    'Quận Hoàn Kiếm',
    'Quận Hoàng Mai',
    'Quận Long Biên',
    'Quận Nam Từ Liêm',
    'Quận Tây Hồ',
    'Quận Thanh Xuân',
    'Thị xã Sơn Tây',
    'Huyện Ba Vì',
    'Huyện Chương Mỹ',
    'Huyện Đan Phượng',
    'Huyện Đông Anh',
    'Huyện Gia Lâm',
    'Huyện Hoài Đức',
    'Huyện Mê Linh',
    'Huyện Mỹ Đức',
    'Huyện Phú Xuyên',
    'Huyện Phúc Thọ',
    'Huyện Quốc Oai',
    'Huyện Sóc Sơn',
    'Huyện Thạch Thất',
    'Huyện Thanh Oai',
    'Huyện Thanh Trì',
    'Huyện Thường Tín',
    'Huyện Ứng Hòa'
  ],
  'TP.HCM': [
    'Quận 1',
    'Quận 2',
    'Quận 3',
    'Quận 4',
    'Quận 5',
    'Quận 6',
    'Quận 7',
    'Quận 8',
    'Quận 9',
    'Quận 10',
    'Quận 11',
    'Quận 12',
    'Quận Phú Nhuận',
    'Quận Gò Vấp',
    'Quận Tân Bình',
    'Quận Tân Phú',
    'Quận Thủ Đức',
    'Huyện Bình Chánh',
    'Quận Bình Tân',
    'Quận Bình Thạnh',
    'Huyện Cần Giờ',
    'Huyện Củ Chi',
    'Huyện Hóc Môn',
    'Huyện Nhà Bè'
  ],
  'An Giang': [
    'Huyện An Phú',
    'Thành phố Châu Đốc',
    'Huyện Châu Phú',
    'Huyện Châu Thành',
    'Huyện Chợ Mới',
    'Thành phố Long Xuyên',
    'Huyện Phú Tân',
    'Thị xã Tân Châu',
    'Huyện Thoại Sơn',
    'Huyện Tịnh Biên',
    'Huyện Tri Tôn'
  ],
  'Bà Rịa-Vũng Tàu': [
    'Thành phố Bà Rịa',
    'Huyện Châu Đức',
    'Huyện đảo Côn Đảo',
    'Huyện Đất Đỏ',
    'Huyện Long Điền',
    'Thị xã Phú Mỹ',
    'Thành phố Vũng Tàu',
    'Huyện Xuyên Mộc'
  ],
  'Bình Dương': [
    'Thành phố Thủ Dầu Một',
    'Thành phố Dĩ An',
    'Thành phố Thuận An',
    'Huyện Bàu Bàng',
    'Huyện Bắc Tân Uyên',
    'Thị xã Bến Cát',
    'Huyện Dầu Tiếng',
    'Huyện Phú Giáo',
    'Thị xã Tân Uyên',
  ],
  'Bình Phước': [
    'Thị xã Bình Long',
    'Huyện Bù Đăng',
    'Huyện Bù Đốp',
    'Huyện Bù Gia Mập',
    'Huyện Chơn Thành',
    'Huyện Đồng Phú',
    'Thành phố Đồng Xoài',
    'Huyện Hớn Quản',
    'Huyện Lộc Ninh',
    'Huyện Phú Riềng',
    'Thị xã Phước Long'
  ],
  'Bình Thuận': [
    'Huyện Bắc Bình',
    'Huyện Đức Linh',
    'Huyện Hàm Tân',
    'Huyện Hàm Thuận Bắc',
    'Huyện Hàm Thuận Nam',
    'Thị xã La Gi',
    'Thành phố Phan Thiết',
    'Huyện đảo Phú Quý',
    'Huyện Tánh Linh',
    'Huyện Tuy Phong'
  ],
  'Bình Định': [
    'Huyện An Lão',
    'Thị xã An Nhơn',
    'Huyện Hoài Ân',
    'Huyện Hoài Nhơn',
    'Huyện Phù Cát',
    'Huyện Phù Mỹ',
    'Thành phố Quy Nhơn',
    'Huyện Tây Sơn',
    'Huyện Tuy Phước',
    'Huyện Vân Canh',
    'Huyện Vĩnh Thạnh'
  ],
  'Bạc Liêu': [
    'Thành phố Bạc Liêu',
    'Huyện Đông Hải',
    'Thị xã Giá Rai',
    'Huyện Hoà Bình',
    'Huyện Hồng Dân',
    'Huyện Phước Long',
    'Huyện Vĩnh Lợi'
  ],
  'Bắc Giang': [
    'Thành phố Bắc Giang',
    'Huyện Hiệp Hòa',
    'Huyện Lạng Giang',
    'Huyện Lục Nam',
    'Huyện Lục Ngạn',
    'Huyện Sơn Động',
    'Huyện Tân Yên',
    'Huyện Việt Yên',
    'Huyện Yên Dũng',
    'Huyện Yên Thế'
  ],
  'Bắc Kạn': [
    'Huyện Ba Bể',
    'Huyện Bạch Thông',
    'Thành phố Bắc Kạn',
    'Huyện Chợ Đồn',
    'Huyện Chợ Mới',
    'Huyện Na Rì',
    'Huyện Ngân Sơn',
    'Huyện Pác Nặm'
  ],
  'Bắc Ninh': [
    'Thành phố Bắc Ninh',
    'Huyện Gia Bình',
    'Huyện Lương Tài',
    'Huyện Quế Võ',
    'Huyện Thuận Thành',
    'Huyện Tiên Du',
    'Thị xã Từ Sơn',
    'Huyện Yên Phong'
  ],
  'Bến Tre': [
    'Huyện Ba Tri',
    'Thành phố Bến Tre',
    'Huyện Bình Đại',
    'Huyện Châu Thành',
    'Huyện Chợ Lách',
    'Huyện Giồng Trôm',
    'Huyện Mỏ Cày Bắc',
    'Huyện Mỏ Cày Nam',
    'Huyện Thạnh Phú'
  ],
  'Cao Bằng': [
    'Huyện Bảo Lạc',
    'Huyện Bảo Lâm',
    'Thành phố Cao Bằng',
    'Huyện Hà Quảng',
    'Huyện Hạ Lang',
    'Huyện Hòa An',
    'Huyện Nguyên Bình',
    'Huyện Phục Hòa',
    'Huyện Quảng Uyên',
    'Huyện Thạch An',
    'Huyện Thông Nông',
    'Huyện Trà Lĩnh',
    'Huyện Trùng Khánh'
  ],
  'Cà Mau': [
    'Thành phố Cà Mau',
    'Huyện Cái Nước',
    'Huyện Đầm Dơi',
    'Huyện Năm Căn',
    'Huyện Ngọc Hiển',
    'Huyện Phú Tân',
    'Huyện Thới Bình',
    'Huyện Trần Văn Thời',
    'Huyện U Minh'
  ],
  'Cần Thơ': [
    'Quận Bình Thủy',
    'Quận Cái Răng',
    'Huyện Cờ Đỏ',
    'Quận Ninh Kiều',
    'Quận Ô Môn',
    'Huyện Phong Điền',
    'Quận Thốt Nốt',
    'Huyện Thới Lai',
    'Huyện Vĩnh Thạnh'
  ],
  'Gia Lai': [
    'Thị xã An Khê',
    'Thị xã Ayun Pa',
    'Huyện Chư Păh',
    'Huyện Chư Prông',
    'Huyện Chư Pưh',
    'Huyện Chư Sê',
    'Huyện Đắk Đoa',
    'Huyện Đak Pơ',
    'Huyện Đức Cơ',
    'Huyện Ia Grai',
    'Huyện Ia Pa',
    "Huyện K'Bang",
    'Huyện Kông Chro',
    'Huyện Krông Pa',
    'Huyện Mang Yang',
    'Huyện Phú Thiện',
    'Thành phố Pleiku'
  ],
  'Hà Giang': [
    'Huyện Bắc Mê',
    'Huyện Bắc Quang',
    'Huyện Đồng Văn',
    'Thành phố Hà Giang',
    'Huyện Hoàng Su Phì',
    'Huyện Mèo Vạc',
    'Huyện Quản Bạ',
    'Huyện Quang Bình',
    'Huyện Vị Xuyên',
    'Huyện Xín Mần',
    'Huyện Yên Minh'
  ],
  'Hà Nam': [
    'Huyện Bình Lục',
    'Huyện Duy Tiên',
    'Huyện Kim Bảng',
    'Huyện Lý Nhân',
    'Thành phố Phủ Lý',
    'Huyện Thanh Liêm'
  ],
  'Hà Tĩnh': [
    'Huyện Can Lộc',
    'Huyện Cẩm Xuyên',
    'Huyện Đức Thọ',
    'Thành phố Hà Tĩnh',
    'Thị xã Hồng Lĩnh',
    'Huyện Hương Khê',
    'Huyện Hương Sơn',
    'Huyện Kỳ Anh',
    'Thị xã Kỳ Anh',
    'Huyện Lộc Hà',
    'Huyện Nghi Xuân',
    'Huyện Thạch Hà',
    'Huyện Vũ Quang'
  ],
  'Hòa Bình': [
    'Huyện Cao Phong',
    'Huyện Đà Bắc',
    'Thành phố Hoà Bình',
    'Huyện Kim Bôi',
    'Huyện Kỳ Sơn',
    'Huyện Lạc Sơn',
    'Huyện Lạc Thủy',
    'Huyện Lương Sơn',
    'Huyện Mai Châu',
    'Huyện Tân Lạc',
    'Huyện Yên Thủy'
  ],
  'Hưng Yên': [
    'Huyện Ân Thi',
    'Thành phố Hưng Yên',
    'Huyện Khoái Châu',
    'Huyện Kim Động',
    'Thị xã Mỹ Hào',
    'Huyện Phù Cừ',
    'Huyện Tiên Lữ',
    'Huyện Văn Giang',
    'Huyện Văn Lâm',
    'Huyện Yên Mỹ'
  ],
  'Hải Dương': [
    'Huyện Bình Giang',
    'Huyện Cẩm Giàng',
    'Thành phố Chí Linh',
    'Huyện Gia Lộc',
    'Thành phố Hải Dương',
    'Huyện Kim Thành',
    'Thị xã Kinh Môn',
    'Huyện Nam Sách',
    'Huyện Ninh Giang',
    'Huyện Thanh Hà',
    'Huyện Thanh Miện',
    'Huyện Tứ Kỳ'
  ],
  'Hải Phòng': [
    'Huyện An Dương',
    'Huyện An Lão',
    'Huyện đảo Bạch Long Vĩ',
    'Huyện đảo Cát Hải',
    'Quận Dương Kinh',
    'Quận Đồ Sơn',
    'Quận Hải An',
    'Quận Hồng Bàng',
    'Quận Kiến An',
    'Huyện Kiến Thụy',
    'Quận Lê Chân',
    'Quận Ngô Quyền',
    'Huyện Thủy Nguyên',
    'Huyện Tiên Lãng',
    'Huyện Vĩnh Bảo'
  ],
  'Hậu Giang': [
    'Huyện Châu Thành',
    'Huyện Châu Thành A',
    'Thị xã Long Mỹ',
    'Huyện Long Mỹ',
    'Thị xã Ngã Bảy',
    'Huyện Phụng Hiệp',
    'Thành phố Vị Thanh',
    'Huyện Vị Thủy'
  ],
  'Khánh Hòa': [
    'Huyện Cam Lâm',
    'Thành phố Cam Ranh',
    'Huyện Diên Khánh',
    'Huyện Khánh Sơn',
    'Huyện Khánh Vĩnh',
    'Thành phố Nha Trang',
    'Thị xã Ninh Hòa',
    'Huyện đảo Trường Sa',
    'Huyện Vạn Ninh'
  ],
  'Kiên Giang': [
    'Huyện An Biên',
    'Huyện An Minh',
    'Huyện Châu Thành',
    'Huyện Giang Thành',
    'Huyện Giồng Riềng',
    'Huyện Gò Quao',
    'Thành phố Hà Tiên',
    'Huyện Hòn Đất',
    'Huyện đảo Kiên Hải',
    'Huyện Kiên Lương',
    'Huyện đảo Phú Quốc',
    'Thành phố Rạch Giá',
    'Huyện Tân Hiệp',
    'Huyện U Minh Thượng',
    'Huyện Vĩnh Thuận'
  ],
  'Kon Tum': [
    'Huyện Đắk Glei',
    'Huyện Đắk Hà',
    'Huyện Đắk Tô',
    "Huyện Ia H'Drai",
    'Huyện Kon Plông',
    'Huyện Kon Rẫy',
    'Thành phố Kon Tum',
    'Huyện Ngọc Hồi',
    'Huyện Sa Thầy',
    'Huyện Tu Mơ Rông'
  ],
  'Lai Châu': [
    'Thành phố Lai Châu',
    'Huyện Mường Tè',
    'Huyện Nậm Nhùn',
    'Huyện Phong Thổ',
    'Huyện Sìn Hồ',
    'Huyện Tam Đường',
    'Huyện Tân Uyên',
    'Huyện Than Uyên'
  ],
  'Long An': [
    'Huyện Bến Lức',
    'Huyện Cần Đước',
    'Huyện Cần Giuộc',
    'Huyện Châu Thành',
    'Huyện Đức Hòa',
    'Huyện Đức Huệ',
    'Thị xã Kiến Tường',
    'Huyện Mộc Hóa',
    'Thành phố Tân An',
    'Huyện Tân Hưng',
    'Huyện Tân Thạnh',
    'Huyện Tân Trụ',
    'Huyện Thạnh Hóa',
    'Huyện Thủ Thừa',
    'Huyện Vĩnh Hưng'
  ],
  'Lào Cai': [
    'Huyện Bảo Thắng',
    'Huyện Bảo Yên',
    'Huyện Bát Xát',
    'Huyện Bắc Hà',
    'Thành phố Lào Cai',
    'Huyện Mường Khương',
    'Thị xã Sa Pa',
    'Huyện Si Ma Cai',
    'Huyện Văn Bàn'
  ],
  'Lâm Đồng': [
    'Huyện Bảo Lâm',
    'Thành phố Bảo Lộc',
    'Huyện Cát Tiên',
    'Huyện Di Linh',
    'Thành phố Đà Lạt',
    'Huyện Đạ Huoai',
    'Huyện Đạ Tẻh',
    'Huyện Đam Rông',
    'Huyện Đơn Dương',
    'Huyện Đức Trọng',
    'Huyện Lạc Dương',
    'Huyện Lâm Hà'
  ],
  'Lạng Sơn': [
    'Huyện Bắc Sơn',
    'Huyện Bình Gia',
    'Huyện Cao Lộc',
    'Huyện Chi Lăng',
    'Huyện Đình Lập',
    'Huyện Hữu Lũng',
    'Thành phố Lạng Sơn',
    'Huyện Lộc Bình',
    'Huyện Tràng Định',
    'Huyện Văn Lãng',
    'Huyện Văn Quan'
  ],
  'Nam Định': [
    'Huyện Giao Thủy',
    'Huyện Hải Hậu',
    'Huyện Mỹ Lộc',
    'Thành phố Nam Định',
    'Huyện Nam Trực',
    'Huyện Nghĩa Hưng',
    'Huyện Trực Ninh',
    'Huyện Vụ Bản',
    'Huyện Xuân Trường',
    'Huyện Ý Yên'
  ],
  'Nghệ An': [
    'Huyện Anh Sơn',
    'Huyện Con Cuông',
    'Thị xã Cửa Lò',
    'Huyện Diễn Châu',
    'Huyện Đô Lương',
    'Thị xã Hoàng Mai',
    'Huyện Hưng Nguyên',
    'Huyện Kỳ Sơn',
    'Huyện Nam Đàn',
    'Huyện Nghi Lộc',
    'Huyện Nghĩa Đàn',
    'Huyện Quế Phong',
    'Huyện Quỳ Châu',
    'Huyện Quỳ Hợp',
    'Huyện Quỳnh Lưu',
    'Huyện Tân Kỳ',
    'Thị xã Thái Hòa',
    'Huyện Thanh Chương',
    'Huyện Tương Dương',
    'Thành phố Vinh',
    'Huyện Yên Thành'
  ],
  'Ninh Bình': [
    'Huyện Gia Viễn',
    'Huyện Hoa Lư',
    'Huyện Kim Sơn',
    'Huyện Nho Quan',
    'Thành phố Ninh Bình',
    'Thành phố Tam Điệp',
    'Huyện Yên Khánh',
    'Huyện Yên Mô'
  ],
  'Ninh Thuận': [
    'Huyện Bác Ái',
    'Huyện Ninh Hải',
    'Huyện Ninh Phước',
    'Huyện Ninh Sơn',
    'Thành phố Phan Rang-Tháp Chàm',
    'Huyện Thuận Bắc',
    'Huyện Thuận Nam'
  ],
  'Phú Thọ': [
    'Huyện Cẩm Khê',
    'Huyện Đoan Hùng',
    'Huyện Hạ Hòa',
    'Huyện Lâm Thao',
    'Thị xã Phú Thọ',
    'Huyện Phù Ninh',
    'Huyện Tam Nông',
    'Huyện Tân Sơn',
    'Huyện Thanh Ba',
    'Huyện Thanh Sơn',
    'Huyện Thanh Thủy',
    'Thành phố Việt Trì',
    'Huyện Yên Lập'
  ],
  'Phú Yên': [
    'Huyện Đông Hòa',
    'Huyện Đồng Xuân',
    'Huyện Phú Hòa',
    'Thị xã Sông Cầu',
    'Huyện Sông Hinh',
    'Huyện Sơn Hòa',
    'Huyện Tây Hòa',
    'Huyện Tuy An',
    'Thành phố Tuy Hòa'
  ],
  'Quảng Bình': [
    'Thị xã Ba Đồn',
    'Huyện Bố Trạch',
    'Thành phố Đồng Hới',
    'Huyện Lệ Thủy',
    'Huyện Minh Hóa',
    'Huyện Quảng Ninh',
    'Huyện Quảng Trạch',
    'Huyện Tuyên Hóa'
  ],
  'Quảng Nam': [
    'Huyện Bắc Trà My',
    'Huyện Duy Xuyên',
    'Huyện Đại Lộc',
    'Thị xã Điện Bàn',
    'Huyện Đông Giang',
    'Huyện Hiệp Đức',
    'Thành phố Hội An',
    'Huyện Nam Giang',
    'Huyện Nam Trà My',
    'Huyện Nông Sơn',
    'Huyện Núi Thành',
    'Huyện Phú Ninh',
    'Huyện Phước Sơn',
    'Huyện Quế Sơn',
    'Thành phố Tam Kỳ',
    'Huyện Tây Giang',
    'Huyện Thăng Bình',
    'Huyện Tiên Phước'
  ],
  'Quảng Ngãi': [
    'Huyện Ba Tơ',
    'Huyện Bình Sơn',
    'Huyện Đức Phổ',
    'Huyện đảo Lý Sơn',
    'Huyện Minh Long',
    'Huyện Mộ Đức',
    'Huyện Nghĩa Hành',
    'Thành phố Quảng Ngãi',
    'Huyện Sơn Hà',
    'Huyện Sơn Tây',
    'Huyện Sơn Tịnh',
    'Huyện Tây Trà',
    'Huyện Trà Bồng',
    'Huyện Tư Nghĩa'
  ],
  'Quảng Ninh': [
    'Huyện Ba Chẽ',
    'Huyện Bình Liêu',
    'Thành phố Cẩm Phả',
    'Huyện đảo Cô Tô',
    'Huyện Đầm Hà',
    'Thị xã Đông Triều',
    'Thành phố Hạ Long',
    'Huyện Hải Hà',
    'Huyện Hoành Bồ',
    'Thành phố Móng Cái',
    'Thị xã Quảng Yên',
    'Huyện Tiên Yên',
    'Thành phố Uông Bí',
    'Huyện đảo Vân Đồn'
  ],
  'Quảng Trị': [
    'Huyện Cam Lộ',
    'Huyện đảo Cồn Cỏ',
    'Huyện Đa Krông',
    'Thành phố Đông Hà',
    'Huyện Gio Linh',
    'Huyện Hải Lăng',
    'Huyện Hướng Hóa',
    'Thị xã Quảng Trị',
    'Huyện Triệu Phong',
    'Huyện Vĩnh Linh'
  ],
  'Sóc Trăng': [
    'Huyện Châu Thành',
    'Huyện Cù Lao Dung',
    'Huyện Kế Sách',
    'Huyện Long Phú',
    'Huyện Mỹ Tú',
    'Huyện Mỹ Xuyên',
    'Thị xã Ngã Năm',
    'Thành phố Sóc Trăng',
    'Huyện Thạnh Trị',
    'Huyện Trần Đề',
    'Thị xã Vĩnh Châu'
  ],
  'Sơn La': [
    'Huyện Bắc Yên',
    'Huyện Mai Sơn',
    'Huyện Mộc Châu',
    'Huyện Mường La',
    'Huyện Phù Yên',
    'Huyện Quỳnh Nhai',
    'Huyện Sông Mã',
    'Huyện Sốp Cộp',
    'Thành phố Sơn La',
    'Huyện Thuận Châu',
    'Huyện Vân Hồ',
    'Huyện Yên Châu'
  ],
  'Thanh Hóa': [
    'Huyện Bá Thước',
    'Thị xã Bỉm Sơn',
    'Huyện Cẩm Thủy',
    'Huyện Đông Sơn',
    'Huyện Hà Trung',
    'Huyện Hậu Lộc',
    'Huyện Hoằng Hóa',
    'Huyện Lang Chánh',
    'Huyện Mường Lát',
    'Huyện Nga Sơn',
    'Huyện Ngọc Lặc',
    'Huyện Như Thanh',
    'Huyện Như Xuân',
    'Huyện Nông Cống',
    'Huyện Quan Hóa',
    'Huyện Quan Sơn',
    'Huyện Quảng Xương',
    'Thành phố Sầm Sơn',
    'Huyện Thạch Thành',
    'Thành phố Thanh Hóa',
    'Huyện Thiệu Hóa',
    'Huyện Thọ Xuân',
    'Huyện Thường Xuân',
    'Huyện Tĩnh Gia',
    'Huyện Triệu Sơn',
    'Huyện Vĩnh Lộc',
    'Huyện Yên Định'
  ],
  'Thái Bình': [
    'Huyện Đông Hưng',
    'Huyện Hưng Hà',
    'Huyện Kiến Xương',
    'Huyện Quỳnh Phụ',
    'Thành phố Thái Bình',
    'Huyện Thái Thụy',
    'Huyện Tiền Hải',
    'Huyện Vũ Thư'
  ],
  'Thái Nguyên': [
    'Huyện Đại Từ',
    'Huyện Định Hóa',
    'Huyện Đồng Hỷ',
    'Thị xã Phổ Yên',
    'Huyện Phú Bình',
    'Huyện Phú Lương',
    'Thành phố Sông Công',
    'Thành phố Thái Nguyên',
    'Huyện Võ Nhai'
  ],
  'Thừa Thiên-Huế': [
    'Huyện A Lưới',
    'Thành phố Huế',
    'Thị xã Hương Thủy',
    'Thị xã Hương Trà',
    'Huyện Nam Đông',
    'Huyện Phong Điền',
    'Huyện Phú Lộc',
    'Huyện Phú Vang',
    'Huyện Quảng Điền'
  ],
  'Tiền Giang': [
    'Huyện Cai Lậy',
    'Thị xã Cai Lậy',
    'Huyện Cái Bè',
    'Huyện Châu Thành',
    'Huyện Chợ Gạo',
    'Thị xã Gò Công',
    'Huyện Gò Công Đông',
    'Huyện Gò Công Tây',
    'Thành phố Mỹ Tho',
    'Huyện Tân Phú Đông',
    'Huyện Tân Phước'
  ],
  'Trà Vinh': [
    'Huyện Càng Long',
    'Huyện Cầu Kè',
    'Huyện Cầu Ngang',
    'Huyện Châu Thành',
    'Thị xã Duyên Hải',
    'Huyện Duyên Hải',
    'Huyện Tiểu Cần',
    'Huyện Trà Cú',
    'Thành phố Trà Vinh'
  ],
  'Tuyên Quang': [
    'Huyện Chiêm Hóa',
    'Huyện Hàm Yên',
    'Huyện Lâm Bình',
    'Huyện Na Hang',
    'Huyện Sơn Dương',
    'Thành phố Tuyên Quang',
    'Huyện Yên Sơn'
  ],
  'Tây Ninh': [
    'Huyện Bến Cầu',
    'Huyện Châu Thành',
    'Huyện Dương Minh Châu',
    'Huyện Gò Dầu',
    'Huyện Hòa Thành',
    'Huyện Tân Biên',
    'Huyện Tân Châu',
    'Thành phố Tây Ninh',
    'Huyện Trảng Bàng'
  ],
  'Vĩnh Long': [
    'Thị xã Bình Minh',
    'Huyện Bình Tân',
    'Huyện Long Hồ',
    'Huyện Mang Thít',
    'Huyện Tam Bình',
    'Huyện Trà Ôn',
    'Thành phố Vĩnh Long',
    'Huyện Vũng Liêm'
  ],
  'Vĩnh Phúc': [
    'Huyện Bình Xuyên',
    'Huyện Lập Thạch',
    'Thành phố Phúc Yên',
    'Huyện Sông Lô',
    'Huyện Tam Dương',
    'Huyện Tam Đảo',
    'Huyện Vĩnh Tường',
    'Thành phố Vĩnh Yên',
    'Huyện Yên Lạc'
  ],
  'Yên Bái': [
    'Huyện Lục Yên',
    'Huyện Mù Cang Chải',
    'Thị xã Nghĩa Lộ',
    'Huyện Trạm Tấu',
    'Huyện Trấn Yên',
    'Huyện Văn Chấn',
    'Huyện Văn Yên',
    'Thành phố Yên Bái',
    'Huyện Yên Bình'
  ],
  'Điện Biên': [
    'Huyện Điện Biên',
    'Huyện Điện Biên Đông',
    'Thành phố Điện Biên Phủ',
    'Huyện Mường Ảng',
    'Huyện Mường Chà',
    'Thị xã Mường Lay',
    'Huyện Mường Nhé',
    'Huyện Nậm Pồ',
    'Huyện Tủa Chùa',
    'Huyện Tuần Giáo'
  ],
  'Đà Nẵng': [
    'Quận Cẩm Lệ',
    'Quận Hải Châu',
    'Huyện Hòa Vang',
    'Huyện đảo Hoàng Sa',
    'Quận Liên Chiểu',
    'Quận Ngũ Hành Sơn',
    'Quận Sơn Trà',
    'Quận Thanh Khê'
  ],
  'Đăk Nông': [
    'Huyện Cư Jút',
    'Huyện Đắk Glong',
    'Huyện Đắk Mil',
    "Huyện Đắk R'lấp",
    'Huyện Đắk Song',
    'Thành phố Gia Nghĩa',
    'Huyện Krông Nô',
    'Huyện Tuy Đức'
  ],
  'Đắk Lắk': [
    'Huyện Buôn Đôn',
    'Thị xã Buôn Hồ',
    'Thành phố Buôn Ma Thuột',
    'Huyện Cư Kuin',
    "Huyện Cư M'gar",
    "Huyện Ea H'leo",
    'Huyện Ea Kar',
    'Huyện Ea Súp',
    'Huyện Krông Ana',
    'Huyện Krông Bông',
    'Huyện Krông Búk',
    'Huyện Krông Năng',
    'Huyện Krông Pắk',
    'Huyện Lắk',
    "Huyện M'Đrăk"
  ],
  'Đồng Nai': [
    'Thành phố Biên Hòa',
    'Huyện Cẩm Mỹ',
    'Huyện Định Quán',
    'Thành phố Long Khánh',
    'Huyện Long Thành',
    'Huyện Nhơn Trạch',
    'Huyện Tân Phú',
    'Huyện Thống Nhất',
    'Huyện Trảng Bom',
    'Huyện Vĩnh Cửu',
    'Huyện Xuân Lộc'
  ],
  'Đồng Tháp': [
    'Thành phố Cao Lãnh',
    'Huyện Cao Lãnh',
    'Huyện Châu Thành',
    'Huyện Hồng Ngự',
    'Thị xã Hồng Ngự',
    'Huyện Lai Vung',
    'Huyện Lấp Vò',
    'Thành phố Sa Đéc',
    'Huyện Tam Nông',
    'Huyện Tân Hồng',
    'Huyện Thanh Bình',
    'Huyện Tháp Mười'
  ]
};
